import setFormRules from './set-form-rules';

export default setFormRules;
